module.exports = __webpack_public_path__ + "img/practice_task_completed.1d00f01e.png";